import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { withLinkClickedEvent } from '../../utils/analytics/click';
import { LinkAnalyticsContext } from '../../utils/analytics/LinkAnalyticsContext';
import { useLinkWarningModal } from './LinkWarningModal/hooks/use-link-warning-modal';
import LinkWarningModal from './LinkWarningModal';
const PACKAGE_DATA = {
  packageName: "@atlaskit/smart-card",
  packageVersion: "27.6.1",
  componentName: 'linkUrl'
};
const Link = withLinkClickedEvent('a');
const LinkUrl = ({
  href,
  children,
  checkSafety = true,
  onClick,
  testId = 'link-with-safety',
  ...props
}) => {
  const {
    isLinkSafe,
    showSafetyWarningModal,
    ...linkWarningModalProps
  } = useLinkWarningModal();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkAnalyticsContext, {
    url: href,
    display: "url"
  }, /*#__PURE__*/React.createElement(Link, _extends({
    "data-testid": testId,
    href: href,
    onClick: e => {
      if (!checkSafety) {
        onClick && onClick(e);
        return;
      }

      // Only call the onClick if the link is safe
      if (isLinkSafe(e, href)) {
        onClick && onClick(e);
      } else {
        showSafetyWarningModal(e, href);
      }
    }
  }, props), children)), checkSafety && /*#__PURE__*/React.createElement(LinkWarningModal, linkWarningModalProps));
};
export default withAnalyticsContext(PACKAGE_DATA)(LinkUrl);